import { useContext } from 'react';
import { shallowEqual } from 'react-redux';

import { TextButton } from '@zillow/constellation-10';

import { RMWContext } from '../../providers/RMWContext';

import { useSelector } from '../../selectors/useSelector';

import type { TextButtonPropsInterface } from '@zillow/constellation-10';

type Props = {
  textStyle?: TextButtonPropsInterface['textStyle'];
};

const ScreeningPreferencesTextButton = ({ textStyle = 'body-sm-bold' }: Props) => {
  const { paths } = useContext(RMWContext);

  const {
    listingAlias,
    isEnabled: isScreeningCriteriaEnabled,
    isSet: isScreeningCriteriaSet,
    dateLastActivatedTimestamp,
  } = useSelector((state) => {
    return {
      listingAlias: state.properties.propertyOverview.listingAlias,
      isEnabled: state.properties.propertyOverview.screeningCriteria.isEnabled,
      isSet: state.properties.propertyOverview.screeningCriteria.isSet,
      dateLastActivatedTimestamp: state.properties.currentProperty.dateLastActivatedTimestamp,
    };
  }, shallowEqual);

  const showScreeningCriteriaCTA = isScreeningCriteriaEnabled && dateLastActivatedTimestamp !== '';

  const screeningCriteriaPath = `${paths.propertiesPage}/${listingAlias}/screening-criteria`;

  if (listingAlias && showScreeningCriteriaCTA === false) {
    return null;
  }

  return (
    <TextButton textStyle={textStyle} asChild data-testid="ScreeningPreferencesTextButton">
      <a href={screeningCriteriaPath}>{isScreeningCriteriaSet ? 'Adjust ' : 'Set '}screening preferences</a>
    </TextButton>
  );
};

export default ScreeningPreferencesTextButton;
